import { Injectable } from '@angular/core';
import { KioskServiceProvider } from '../kiosk-service/kiosk-service';

/*
  Generated class for the AppConfigProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AppConfigProvider {

  // -- Start AppConfig
  public appId = window['APP_ID'];

  constructor(
    private kioskService: KioskServiceProvider
  ) {

    if (window.location.search.charAt(0) === '?') {
      const params: any = {};
      window.location.search.substr(1)
        .split('&')
        .forEach(str => {
          const [key, val] = str.split('=');
          params[key] = decodeURI(val);
        });
      console.log(params);
      if (params.APP_ID) {
        this.appId = parseInt(params.APP_ID, 10);
      }
    }

    if (kioskService.isKiosk) {
      kioskService.initialize(this.appId);
    }

    console.log(this.appId);
  }


}



// WEBPACK FOOTER //
// ./src/providers/app-config/app-config.ts